module.exports = __webpack_public_path__ + "images/sgp/10x25/organize.webp";